import { apiFetch } from "./client";
import type { LoadSnapshot } from "./types";

/** Published day-load snapshot API (portals run off these). */

export interface SnapshotUpdatePayload {
  status?: string | null;
  depot_reference_number?: string | null;
}

export async function publishDaySnapshot(
  day: string,
): Promise<{ published: number; day: string }> {
  return apiFetch<{ published: number; day: string }>("/snapshots/publish", {
    method: "POST",
    body: JSON.stringify({ day }),
  });
}

export async function listDaySnapshots(day: string): Promise<LoadSnapshot[]> {
  const qs = new URLSearchParams({ day });
  return apiFetch<LoadSnapshot[]>(`/snapshots?${qs.toString()}`);
}

export async function listHaulierSnapshots(): Promise<LoadSnapshot[]> {
  return apiFetch<LoadSnapshot[]>("/snapshots/haulier");
}

export async function updateSnapshot(
  id: number,
  data: SnapshotUpdatePayload,
): Promise<LoadSnapshot> {
  return apiFetch<LoadSnapshot>(`/snapshots/${id}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}
